// Prompt 18 D — single source of truth for supported GLs in the UI.
// Mirrors backend/platforms.py (tests assert they match).
export const PLATFORMS = [
  { key: "quickbooks", name: "QuickBooks Online", short: "QuickBooks Online", vendor: "Intuit", status: "available", method: "oauth", note: "" },
  { key: "xero", name: "Xero", short: "Xero", vendor: "Xero", status: "available", method: "oauth", note: "limited pilot capacity" },
  { key: "zoho", name: "Zoho Books", short: "Zoho Books", vendor: "Zoho", status: "available", method: "oauth", note: "" },
  { key: "bc", name: "Microsoft Dynamics 365 Business Central", short: "Business Central", vendor: "Microsoft", status: "available", method: "oauth", note: "your Microsoft admin may need to approve" },
  { key: "freshbooks", name: "FreshBooks", short: "FreshBooks", vendor: "FreshBooks", status: "beta", method: "oauth", note: "" },
  { key: "odoo", name: "Odoo", short: "Odoo", vendor: "Odoo", status: "hidden", method: "api_key", note: "" },
  { key: "netsuite", name: "NetSuite", short: "NetSuite", vendor: "Oracle", status: "coming_soon", method: "oauth", note: "" },
];

export const publicPlatforms = () => PLATFORMS.filter((p) => p.status !== "hidden");
export const livePlatforms = () => PLATFORMS.filter((p) => p.status === "available" || p.status === "beta");
export const comingSoon = () => PLATFORMS.filter((p) => p.status === "coming_soon");
export const isHidden = (key) => PLATFORMS.some((p) => p.key === key && p.status === "hidden");

export function joinList(items, conj = "and", oxford = false) {
  if (items.length <= 1) return items.join("");
  const sep = oxford && items.length > 2 ? "," : "";
  return `${items.slice(0, -1).join(", ")}${sep} ${conj} ${items[items.length - 1]}`;
}

export const label = (p) => (p.status === "beta" ? `${p.name} (beta)` : p.name);
